import React, { useEffect, useState } from 'react'
import Close from './../assets/images/close_icon.svg'
import { useTranslation } from 'react-i18next';
import InputFields from '../components/InputFields';
import { useAddFarm, useUpdateFarm } from '../hooks/hooks';
import { showSuccessToast } from '../components/common';
import SelectPhoneNew from "./SelectPhoneNew";
import { PhoneNumberUtil } from "google-libphonenumber";
import { CloseIcon, LoadingIcon, NoDataFarmI } from '../assets/icons/icon';
import { InputF } from '../components/Common/CommonInput';

function AddFarmModal({ isOpen, onClose, isEdit, isEditItem, isFromOrder }) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState({ _id: "", farmName: "", landmark: "", address: "", isActive: true, contactNumber: "" });
  const [Error, setError] = useState({ farmName: "", landmark: "", address: "", isActive: "", contactNumber: "" });

  const [isLoading, setIsLoading] = useState(false);
  const { mutate: addFarms } = useAddFarm();
  const { mutate: updateFarms } = useUpdateFarm();

  const [inputMobileData, setInputMobileData] = useState({
    country_code: '',
    phone_number: '',
  });


  useEffect(() => {
    if (isEdit && isEditItem) {
      setInputValue({
        _id: isEditItem._id || "",
        farmName: isEditItem.farmName || "",
        landmark: isEditItem.landmark || '',
        address: isEditItem.address || '',
        isActive: isEditItem.isActive ? true : false,
        contactNumber: isEditItem.contactNumber || '',
      });
      setInputMobileData((prevData) => ({
        ...prevData,
        phone_number: isEditItem.contactNumber,
      }));
    }
  }, [isEdit, isEditItem]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue({
      ...inputValue,
      [name]: value,
    });
    setError({ ...Error, farmName: "", landmark: "", address: "", isActive: "" });
  };

  const phoneUtil = PhoneNumberUtil.getInstance();

  const isPhoneValid = (phone) => {
    try {
      return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    } catch (error) {
      return false;
    }
  };

  const onSubmit = () => {
    const isValid = isPhoneValid(inputValue.contactNumber)
    if (inputValue.farmName.toString().trim() === "") {
      setError({ ...Error, farmName: t('Farm_Name_Er') });
      return;
    }

    if (inputValue.landmark.toString().trim() === "") {
      setError({ ...Error, landmark: t('Landmark_Er') });
      return;
    }

    if (inputValue.address.toString().trim() === "") {
      setError({ ...Error, address: t('Address_Er') });
      return;
    }

    if (inputValue.isActive === "") {
      setError({ ...Error, isActive: t('IsActive_Er') });
      return;
    }

    if (inputValue.contactNumber === "+91") {
      inputValue.contactNumber = "";
    }

    // if (!isValid) {
    //     setError({ ...Error, contactNumber: t('Contact_Valid_Er') });
    //     return;
    // }

    setIsLoading(true);

    if (isEdit) {
      updateFarms(inputValue, {
        onSuccess: (res) => {
          showSuccessToast(res?.data?.message);
          onClose({ isRefresh: true, farm: res?.data.data });
          setIsLoading(false);
          setInputValue({ ...inputValue, farmName: "", landmark: "", address: "", isActive: true });
          setError({ ...Error, farmName: "", landmark: "", address: "", isActive: true, all: "" });
        },
        onError: (err) => {
          setIsLoading(false);
          setError({ ...Error, all: err.response.data.error });
        },
      });
    }
    else {
      addFarms(inputValue, {
        onSuccess: (res) => {
          showSuccessToast(res?.data?.message);
          onClose({ isRefresh: true, farm: res?.data.data });
          setIsLoading(false);
          setInputValue({ ...inputValue, farmName: "", landmark: "", address: "", isActive: true });
          setError({ ...Error, farmName: "", landmark: "", address: "", isActive: true, all: "" });

        },
        onError: (err) => {
          setIsLoading(false);
          setError({ ...Error, all: err.response.data.error });
        },
      });
    }
  }


  return (
    <>
      {isOpen && (
        <div className={`fixed inset-0 bg-black  flex items-center justify-center z-50 p-4 ${isFromOrder ? ' bg-opacity-60 backdrop-blur-md' : 'backdrop-blur-sm bg-opacity-50'}`}>
          <div className="bg-white rounded-2xl shadow-xl max-w-2xl w-full h-[90vh] flex flex-col">
            {/* Fixed Header */}
            <div className="bg-gradient-to-r from-green-500 to-green-600 px-6 py-4 rounded-t-2xl flex-shrink-0">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
                    <NoDataFarmI className='w-5 h-5 text-white' />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white">
                      {isEdit ? t('update_farm') : t('add_new_farm')}
                    </h3>
                    <p className="text-green-100 text-sm">
                      {isEdit ? t('update_farm_info') : t('add_farm_details')}
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => {
                    setInputValue({ ...inputValue, farmName: "", landmark: "", address: "", isActive: true });
                    setError({ ...Error, farmName: "", landmark: "", address: "", isActive: "" });
                    onClose({ isRefresh: false, farm: null });
                  }}
                  className="p-2 bg-white bg-opacity-20 rounded-lg hover:bg-opacity-30 transition-all duration-200"
                >
                  <CloseIcon />
                </button>
              </div>
            </div>

            {/* Scrollable Content */}
            <div className="flex-1 overflow-y-auto p-6">
              <div className="space-y-6">
                {/* Farm Name */}
                <div>
                  <label className="text-sm font-medium text-gray-700 mb-2 block">
                    {t('farm_name')}
                  </label>
                  <InputFields
                    name="farmName"
                    label="farm name"
                    type="text"
                    placeholder={t('pls_farm_name')}
                    isHideLabel="false"
                    isFixedLabel="true"
                    disabled={isLoading}
                    handleChange={(e) => handleChange(e)}
                    value={inputValue?.farmName}
                    className="w-full px-4 py-3 text-gray-900 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 hover:bg-gray-50"
                  />
                  {Error?.farmName && <div className="text-red-500 text-sm mt-1">{Error?.farmName}</div>}
                 
                </div>

                {/* Landmark */}
                <div>
                  <label className="text-sm font-medium text-gray-700 mb-2 block">
                    {t('landmark')}
                  </label>
                  <InputFields
                    name="landmark"
                    label="landmark"
                    type="text"
                    placeholder={t('pls_landmark')}
                    isHideLabel="false"
                    isFixedLabel="true"
                    disabled={isLoading}
                    handleChange={(e) => handleChange(e)}
                    value={inputValue?.landmark}
                    className="w-full px-4 py-3 text-gray-900 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 hover:bg-gray-50"
                  />
                  {Error?.landmark && <div className="text-red-500 text-sm mt-1">{Error?.landmark}</div>}
                </div>

                {/* Address */}
                <div>
                  <label className="text-sm font-medium text-gray-700 mb-2 block">
                    {t('address')}
                  </label>
                  <textarea
                    name="address"
                    placeholder={t('pls_address')}
                    disabled={isLoading}
                    onChange={(e) => handleChange(e)}
                    value={inputValue?.address}
                    className="w-full px-4 py-3 text-gray-900 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 hover:bg-gray-50 resize-none h-24"
                  />
                  {Error?.address && <div className="text-red-500 text-sm mt-1">{Error?.address}</div>}
                </div>

                {/* Contact Number */}
                <div>
                  <label className="text-sm font-medium text-gray-700 mb-2 block">
                    {t('Contact_Number')}
                  </label>
                  <SelectPhoneNew
                    inputMobileData={inputMobileData}
                    setInputValue={setInputMobileData}
                    setErrors={setError}
                    detectedCountry='IN'
                    inputValueA={inputValue} setInputValueA={setInputValue}
                  />
                  {Error?.contactNumber && <div className="text-red-500 text-sm mt-1">{Error?.contactNumber}</div>}
                </div>

                {/* Status */}
                <div>
                  <label className="text-sm font-medium text-gray-700 mb-3 block">
                    {t('pls_isactive')}
                  </label>
                  <div className="flex gap-6">
                    <label className="flex items-center gap-3 cursor-pointer">
                      <div className="relative">
                        <input
                          type="radio"
                          name="isActive"
                          value="true"
                          checked={inputValue?.isActive === true}
                          onChange={(e) => handleChange({ target: { name: 'isActive', value: true } })}
                          disabled={isLoading}
                          className="w-4 h-4 text-green-500 border-gray-300 focus:ring-green-500 cursor-pointer"
                        />
                      </div>
                      <span className="text-gray-700">{t('lbl_active')}</span>
                    </label>
                    <label className="flex items-center gap-3 cursor-pointer">
                      <div className="relative">
                        <input
                          type="radio"
                          name="isActive"
                          value="false"
                          checked={inputValue?.isActive === false}
                          onChange={(e) => handleChange({ target: { name: 'isActive', value: false } })}
                          disabled={isLoading}
                          className="w-4 h-4 text-green-500 border-gray-300 focus:ring-green-500 cursor-pointer"
                        />
                      </div>
                      <span className="text-gray-700">{t('lbl_inactive')}</span>
                    </label>
                  </div>
                  {Error?.isActive && <div className="text-red-500 text-sm mt-1">{Error?.isActive}</div>}
                </div>

                {/* Error Message */}
                {Error?.all && (
                  <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                    <div className="flex items-center">
                      <svg className="w-5 h-5 text-red-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span className="text-red-700 text-sm">{Error?.all}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Fixed Footer */}
            <div className="border-t border-gray-200 px-6 py-4 flex-shrink-0">
              <div className="flex gap-3 justify-end">
                <button
                  onClick={() => {
                    setInputValue({ ...inputValue, farmName: "", landmark: "", address: "", isActive: true });
                    setError({ ...Error, farmName: "", landmark: "", address: "", isActive: "" });
                    onClose({ isRefresh: false, farm: null });
                  }}
                  className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-all duration-200 font-medium"
                  disabled={isLoading}
                >
                  {t('btnCancel')}
                </button>
                <button
                  className="px-6 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-all duration-200 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed font-medium"
                  onClick={onSubmit}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <LoadingIcon />
                      Processing...
                    </>
                  ) : (
                    isEdit ? t('btnUpdate') : t('btnSave')
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default AddFarmModal